import styled from "styled-components";
import { Section } from "../layout/style";
import QRCode from "../img/drw-demo/adobe-express-qr-code.svg";

const ContentContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 20px;

`;

const ColumnContainer = styled.div`
    flex: 1;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const RestyledSection = styled(Section)`
    padding: 0px;

    // margin: 0px;

`;

const QRCodeContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    & img {
        width: 60%;
    }
`;

const LearnMoreSlide = () => {



    return <ContentContainer>
        <ColumnContainer>
            <Section>
                <p>Want to learn more? Reach out:</p>
                <p>Steven Geofrey: s.geofrey@northeastern.edu</p>
                <p>Ilya Vidrin: i.vidrin@northeastern.edu</p>
            </Section>
        </ColumnContainer>
        <ColumnContainer>
            <QRCodeContainer>
                <img src={QRCode} />
            </QRCodeContainer>
        </ColumnContainer>
    </ContentContainer>;
}

export default LearnMoreSlide;